export enum EligibleJobStatus {
  OPEN = 'open',
  PENDING_COUNTER = 'pending-counter',
}

export interface IEligibleJob {
  id: string;
  status: EligibleJobStatus;
  localDate: string;
  localEndTime: string;
  localStartTime: string;
  localTimezone: string;
  professionName: string;
  specialty: string;
}

export interface IGetEligibleJobsResult {
  jobs: IEligibleJob[];
  page: number;
  limit: number;
  total: number;
}
